import styled from "styled-components";

export const UploadItemList = styled.div`
    .ant-upload-list-item-name {
        flex: none !important;
    }
`;
